"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItemProgramV2 = exports.ItemProgramV2 = void 0;
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const anchor_1 = require("@project-serum/anchor");
const ItemInstruction = __importStar(require("../instructions/itemv2"));
const itemv2_1 = require("../state/itemv2");
class ItemProgramV2 extends sol_kit_1.Program.Program {
    constructor() {
        super();
        this.PROGRAM_ID = itemv2_1.ITEMV2_ID;
        this.instruction = new ItemInstruction.Instruction({ program: this });
    }
    async createItemClass(args, options) {
        const [itemClass, signers, instructions] = await this.instruction.createItemClass(args);
        const result = await this.sendWithRetry(instructions, signers, options);
        return [itemClass, result];
    }
    // TODO: chunk the returned instructions
    async addItemsToItemClass(accounts, options) {
        const ixns = await this.instruction.addItemsToItemClass(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async createPack(accounts, args, options) {
        const [ix, pack] = await this.instruction.createPack(accounts, args);
        const result = await this.sendWithRetry([ix], [], options);
        return [result, pack];
    }
    async createRecipe(accounts, args, options) {
        const ix = await this.instruction.createRecipe(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async revertBuild(accounts, options) {
        const ix = await this.instruction.revertBuild(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async buildSimpleBuild(accounts, args, options) {
        const ix = await this.instruction.buildSimpleBuild(accounts, args);
        return await this.sendWithRetry(ix, [], options);
    }
    async startBuild(accounts, args, options) {
        const ix = await this.instruction.startBuild(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async addIngredient(accounts, args, options) {
        const ixns = await this.instruction.addIngredient(accounts, args);
        return await this.sendWithRetry(ixns, [], options);
    }
    async verifyIngredient(accounts, args, options) {
        const ix = await this.instruction.verifyIngredient(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async verifyIngredientTest(accounts, args, options) {
        const ix = await this.instruction.verifyIngredientMerkleTreeTest(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async completeBuild(accounts, args, options) {
        const ix = await this.instruction.completeBuild(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async receiveItem(accounts, options) {
        const ixnGroups = await this.instruction.receiveItem(accounts);
        const resultPromises = [];
        for (const group of ixnGroups) {
            const resultPromise = this.sendWithRetry(group, [], options);
            resultPromises.push(resultPromise);
        }
        const results = await Promise.all(resultPromises);
        return results;
    }
    async applyBuildEffect(accounts, options) {
        const ix = await this.instruction.applyBuildEffect(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async returnIngredient(accounts, options) {
        const ixns = await this.instruction.returnIngredient(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async destroyIngredient(accounts, options) {
        const ixns = await this.instruction.destroyIngredient(accounts);
        return await this.sendWithRetry(ixns, [], options);
    }
    async closeBuild(accounts, options) {
        const ix = await this.instruction.closeBuild(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async escrowPayment(accounts, options) {
        const ix = await this.instruction.escrowPayment(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async transferPayment(accounts, options) {
        const ix = await this.instruction.transferPayment(accounts);
        return await this.sendWithRetry([ix], [], options);
    }
    async createBuildPermit(accounts, args, options) {
        const ix = await this.instruction.createBuildPermit(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async createDeterministicIngredient(accounts, args, options) {
        const ix = await this.instruction.createDeterministicIngredient(accounts, args);
        return await this.sendWithRetry([ix], [], options);
    }
    async releaseFromEscrow(accounts, args, options) {
        const ixns = await this.instruction.releaseFromEscrow(accounts, args);
        return await this.sendWithRetry(ixns, [], options);
    }
    async migrateBuildAccount(build, recipe, options) {
        const ixns = await this.instruction.migrateBuildAccount(build, recipe);
        return await this.sendWithRetry(ixns, [], options);
    }
    async migrateItemClassAccount(itemClass, options) {
        const ix = await this.instruction.migrateItemClassAccount(itemClass);
        return await this.sendWithRetry([ix], [], options);
    }
    async getItemClass(itemClass) {
        let itemClassData;
        try {
            itemClassData = await this.client.account.itemClass.fetch(itemClass);
        }
        catch (_e) {
            return null;
        }
        let recipeIndex = null;
        if (itemClassData.recipeIndex !== null) {
            recipeIndex = new anchor_1.BN(itemClassData.recipeIndex);
        }
        const recipes = [];
        if (recipeIndex !== null) {
            for (let i = 0; i <= recipeIndex.toNumber(); i++) {
                const recipeAddr = itemv2_1.getRecipePda(itemClass, new anchor_1.BN(i));
                let recipeData;
                try {
                    recipeData = await this.client.account.recipeV2.fetch(recipeAddr);
                }
                catch (e) {
                    try {
                        console.log(`Error fetching v2 recipe ${e}. Falling back to v1`);
                        recipeData = await this.client.account.recipe.fetch(recipeAddr);
                    }
                    catch (_e) {
                        recipeData = null;
                    }
                }
                // get recipe ingredients
                const ingredients = [];
                for (const recipeIngredient of recipeData.ingredients) {
                    const ingredient = {
                        itemClass: new anchor_1.web3.PublicKey(recipeIngredient.itemClass),
                        requiredAmount: new anchor_1.BN(recipeIngredient.requiredAmount),
                        buildEffect: recipeIngredient.buildEffect,
                    };
                    ingredients.push(ingredient);
                }
                // get payment data
                let payment = null;
                if (recipeData.payment) {
                    payment = {
                        amount: new anchor_1.BN(recipeData.payment.amount),
                        treasury: new anchor_1.web3.PublicKey(recipeData.payment.treasury),
                    };
                }
                const selectableOutputs = [];
                for (const output of recipeData.selectableOutputs) {
                    const choices = [];
                    for (const choice of output.choices) {
                        choices.push({
                            outputId: Number(choice.outputId),
                            mint: new anchor_1.web3.PublicKey(choice.mint),
                            amount: new anchor_1.BN(choice.amount),
                        });
                    }
                    selectableOutputs.push({
                        groupId: Number(output.groupId),
                        choices: choices,
                    });
                }
                const recipe = {
                    recipeType: itemv2_1.convertToRecipeType(recipeData.recipeType),
                    itemClass: itemClass,
                    recipeIndex: new anchor_1.BN(i),
                    payment: payment,
                    buildEnabled: Boolean(recipeData.buildEnabled),
                    ingredients: ingredients,
                    buildPermitRequired: Boolean(recipeData.buildPermitRequired),
                    selectableOutputs: selectableOutputs,
                };
                recipes.push(recipe);
            }
        }
        const mode = itemv2_1.parseItemClassMode(itemClassData);
        const data = {
            name: String(itemClassData.name),
            authorityMint: new anchor_1.web3.PublicKey(itemClassData.authorityMint),
            recipeIndex: recipeIndex,
            recipes: recipes,
            mode: mode,
        };
        return data;
    }
    async getBuild(build) {
        let buildDataRaw;
        try {
            buildDataRaw = await this.client.account.build.fetch(build);
        }
        catch (_e) {
            return null;
        }
        const buildIngredientData = [];
        for (const rawIngredient of buildDataRaw.ingredients) {
            const mints = [];
            for (const rawIngredientMint of rawIngredient.mints) {
                mints.push({
                    mint: new anchor_1.web3.PublicKey(rawIngredientMint.mint),
                    buildEffectApplied: rawIngredientMint.buildEffectApplied,
                });
            }
            buildIngredientData.push({
                itemClass: new anchor_1.web3.PublicKey(rawIngredient.itemClass),
                currentAmount: new anchor_1.BN(rawIngredient.currentAmount),
                requiredAmount: new anchor_1.BN(rawIngredient.requiredAmount),
                buildEffect: rawIngredient.buildEffect,
                mints: mints,
                isDeterministic: Boolean(rawIngredient.isDeterministic),
            });
        }
        const buildOutput = { items: [] };
        for (const output of buildDataRaw.output.items) {
            buildOutput.items.push({
                mint: new anchor_1.web3.PublicKey(output.mint),
                amount: new anchor_1.BN(output.amount),
                received: Boolean(output.received),
            });
        }
        // detect payment
        let paymentData = null;
        const payment = buildDataRaw.payment;
        if (payment !== null) {
            paymentData = {
                status: itemv2_1.convertToPaymentStatus(payment.status),
                paymentDetails: {
                    treasury: new anchor_1.web3.PublicKey(payment.paymentDetails.treasury),
                    amount: new anchor_1.BN(payment.paymentDetails.amount),
                },
            };
        }
        const buildData = {
            address: build,
            recipe: new anchor_1.web3.PublicKey(buildDataRaw.recipe),
            builder: new anchor_1.web3.PublicKey(buildDataRaw.builder),
            itemClass: new anchor_1.web3.PublicKey(buildDataRaw.itemClass),
            output: buildOutput,
            payment: paymentData,
            ingredients: buildIngredientData,
            status: itemv2_1.convertToBuildStatus(buildDataRaw.status),
            buildPermitInUse: Boolean(buildDataRaw.buildPermitInUse),
        };
        return buildData;
    }
    async getItem(item) {
        let itemDataRaw;
        try {
            itemDataRaw = await this.client.account.item.fetch(item);
        }
        catch (_e) {
            return null;
        }
        let cooldown = null;
        if (itemDataRaw.itemState.nonFungible.cooldown !== null) {
            cooldown = new anchor_1.BN(itemDataRaw.itemState.nonFungible.cooldown);
        }
        const itemData = {
            initialized: itemDataRaw.initialized,
            itemMint: new anchor_1.web3.PublicKey(itemDataRaw.itemMint),
            itemState: {
                cooldown: cooldown,
                durability: new anchor_1.BN(itemDataRaw.itemState.nonFungible.durability),
            },
        };
        return itemData;
    }
    async getRecipe(recipe) {
        let recipeDataRaw;
        try {
            recipeDataRaw = await this.client.account.recipeV2.fetch(recipe);
        }
        catch (e) {
            try {
                console.log(`Error fetching v2 recipe ${e}. Falling back to v1`);
                recipeDataRaw = await this.client.account.recipe.fetch(recipe);
            }
            catch (_e) {
                return null;
            }
        }
        let payment = null;
        if (recipeDataRaw.payment) {
            payment = {
                treasury: new anchor_1.web3.PublicKey(recipeDataRaw.payment.treasury),
                amount: new anchor_1.BN(recipeDataRaw.payment.amount),
            };
        }
        const ingredients = [];
        for (const ingredient of recipeDataRaw.ingredients) {
            ingredients.push({
                itemClass: new anchor_1.web3.PublicKey(ingredient.itemClass),
                requiredAmount: new anchor_1.BN(ingredient.requiredAmount),
                buildEffect: ingredient.buildEffect,
            });
        }
        const selectableOutputs = [];
        for (const output of recipeDataRaw.selectableOutputs) {
            const choices = [];
            for (const choice of output.choices) {
                choices.push({
                    outputId: Number(choice.outputId),
                    mint: new anchor_1.web3.PublicKey(choice.mint),
                    amount: new anchor_1.BN(choice.amount),
                });
            }
            selectableOutputs.push({
                groupId: Number(output.groupId),
                choices: choices,
            });
        }
        const recipeData = {
            recipeType: itemv2_1.convertToRecipeType(recipeDataRaw.recipeType),
            recipeIndex: new anchor_1.BN(recipeDataRaw.recipeIndex),
            itemClass: new anchor_1.web3.PublicKey(recipeDataRaw.itemClass),
            buildEnabled: Boolean(recipeDataRaw.buildEnabled),
            payment: payment,
            ingredients: ingredients,
            buildPermitRequired: Boolean(recipeDataRaw.buildPermitRequired),
            selectableOutputs: selectableOutputs,
        };
        return recipeData;
    }
    async getPack(pack) {
        let packDataRaw;
        try {
            packDataRaw = await this.client.account.pack.fetch(pack);
        }
        catch (_e) {
            return null;
        }
        const packData = {
            address: pack,
            opened: Boolean(packDataRaw.opened),
            itemClass: new anchor_1.web3.PublicKey(packDataRaw.itemClass),
            id: new anchor_1.BN(packDataRaw.id),
            contentsHash: Uint8Array.from(packDataRaw.contentsHash),
        };
        return packData;
    }
    async getPacks(itemClass) {
        const itemClassData = await this.getItemClass(itemClass);
        if (itemClassData.mode.kind !== "Pack") {
            throw new Error(`ItemClass ${itemClass.toString()} is not configured for Packs`);
        }
        // get all pack pdas
        const packIndex = itemClassData.mode.index.toNumber();
        const packAddresses = [];
        for (let i = 0; i < packIndex; i++) {
            packAddresses.push(itemv2_1.getPackPda(itemClass, new anchor_1.BN(i)));
        }
        console.log("found %d possible packs", packAddresses.length);
        // fetch all packs at once
        const fetchPackDataPromises = [];
        for (const pack of packAddresses) {
            fetchPackDataPromises.push(this.getPack(pack));
        }
        const allPackData = await Promise.all(fetchPackDataPromises);
        const availablePacks = [];
        for (const packData of allPackData) {
            // skip if pda data doesnt exist
            if (packData === null || packData === undefined) {
                continue;
            }
            // skip if pack data is already opened
            if (packData.opened) {
                continue;
            }
            availablePacks.push(packData);
        }
        console.log("found %d available packs", availablePacks.length);
        return availablePacks;
    }
    async getBuildPermit(buildPermit) {
        let buildPermitDataRaw;
        try {
            buildPermitDataRaw = await this.client.account.buildPermit.fetch(buildPermit);
        }
        catch (_e) {
            return null;
        }
        const buildPermitData = {
            itemClass: new anchor_1.web3.PublicKey(buildPermitDataRaw.itemClass),
            builder: new anchor_1.web3.PublicKey(buildPermitDataRaw.builder),
            remainingBuilds: Number(buildPermitDataRaw.remainingBuilds),
        };
        return buildPermitData;
    }
    async getDeterministicIngredient(deterministicIngredient) {
        let deterministicIngredientDataRaw;
        try {
            deterministicIngredientDataRaw =
                await this.client.account.deterministicIngredient.fetch(deterministicIngredient);
        }
        catch (_e) {
            return null;
        }
        const outputs = [];
        for (const output of deterministicIngredientDataRaw.outputs) {
            outputs.push({
                mint: new anchor_1.web3.PublicKey(output.mint),
                amount: new anchor_1.BN(output.amount),
            });
        }
        const recipes = [];
        for (const r of deterministicIngredientDataRaw.recipes) {
            recipes.push(new anchor_1.web3.PublicKey(r));
        }
        const deterministicIngredientData = {
            recipes: recipes,
            ingredientMint: new anchor_1.web3.PublicKey(deterministicIngredientDataRaw.ingredientMint),
            outputs: outputs,
        };
        return deterministicIngredientData;
    }
}
exports.ItemProgramV2 = ItemProgramV2;
ItemProgramV2.PREFIX = "item_v2";
async function getItemProgramV2(anchorWallet, env, customRpcUrl) {
    if (anchorWallet.secretKey) {
        return ItemProgramV2.getProgramWithWalletKeyPair(ItemProgramV2, anchorWallet, env, customRpcUrl);
    }
    return ItemProgramV2.getProgramWithWallet(ItemProgramV2, anchorWallet, env, customRpcUrl);
}
exports.getItemProgramV2 = getItemProgramV2;
